import { WHY_CHOOSE } from "@/lib/content";

export default function WhyChooseUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="relative bg-white py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">06 — Why Choose Salihi Group</span>
          </div>
          <h2 className="font-serif text-navy text-3xl md:text-4xl lg:text-5xl font-light leading-[1.1] tracking-[-0.01em]">
            A partner built for <em className="text-gold not-italic">long-term</em> engagements.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-softgray border border-softgray">
          {WHY_CHOOSE.map((item, i) => (
            <div key={i} data-testid={`why-choose-${i}`}
                 className={`bg-white p-8 md:p-12 group ${i === 4 ? "md:col-span-2" : ""}`}>
              <div className="flex items-baseline gap-4 mb-5">
                <span className="section-index tabular-nums">0{i + 1}</span>
                <span className="gold-hairline" />
              </div>
              <h3 className="font-serif text-navy text-2xl md:text-[28px] leading-tight font-normal mb-4">
                {item.title}
              </h3>
              <p className="text-mutedink text-base md:text-[17px] leading-relaxed font-light max-w-2xl">
                {item.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
